import { useQuery } from '@tanstack/react-query';
import type { ToolListResponse } from '@bridgewerk/shared';
import { getApiClient } from '../../../lib/api-client.js';
import { toolKeys } from '../../../lib/query-keys.js';

export interface UseToolLifeResult {
  readonly data: ToolListResponse | undefined;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly refetch: () => void;
}

export function useToolLife(
  shopId: string | null,
  machineId: string | null,
): UseToolLifeResult {
  const enabled = Boolean(shopId && machineId);

  const query = useQuery({
    queryKey: shopId && machineId ? toolKeys.list(shopId, machineId) : ['tools', 'none'],
    queryFn: () => getApiClient().getMachineTools(shopId ?? '', machineId ?? ''),
    enabled,
    staleTime: 30_000,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => { void query.refetch(); },
  };
}
